const styles = theme => ({
  name: {
    fontWeight: 500,
  },
  price: {
    color: theme.palette.primary.main,
    margin: '15px 0',
    fontSize: 36,
  },
  imgListContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    overflow: 'hidden',
    marginTop: 15,
  },
  imgList: {
    flexWrap: 'nowrap',
    willChange: 'transform',
    overflowX: 'auto',
    width: '100%',
  },
  gridListTileRoot: {
    cursor: 'pointer',
  },
  gridListTileTile: {
    padding: 6,
    boxSizing: 'border-box',
  },
  itemDescriptionContainer: {
    padding: '0 32px',
    boxSizing: 'border-box',
  },
  itemAvatarContainer: {
    display: 'flex',
    padding: 15,
    boxSizing: 'border-box',
  },
  itemOwnerNameContainer: {
    width: 'calc(100% - 60px)',
    padding: 10,
    boxSizing: 'border-box',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/sections/items/styles.js